module.exports = __webpack_public_path__ + "img/icons BFr_17.01df841d.svg";